import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'primereact/button';
import { Password } from 'primereact/password';
import logo from '../assets/logo.png';
import { Toast } from 'primereact/toast';

export const Login = () => {
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const toast = useRef(null);

  useEffect(() => {
    const password = localStorage.getItem('backend_password');
    if (password) {
      navigate('/chat');
    }
  }, []);

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const handleValidatePassword = () => {
    fetch('https://chatbot.ager-agro.es/api_garanango_powerbi/login', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ password: password }),
    })
    .then(response => {
      if (response.status === 200) {
        localStorage.setItem('backend_password', password);
        navigate('/chat');
      } else {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Contraseña incorrecta' });
      }
    })
    .catch(error => {
      toast.current.show({ severity: 'error', summary: 'Error', detail: 'Contraseña incorrecta' });
    });
  };

  return (
    <div className="p-fluid flex flex-column align-items-center w-full">
        <Toast ref={toast} />
      <header 
        className={`flex p-ai-center p-p-3 p-shadow-3 my-3 w-full pb-3 justify-content-center`}
        style={{ borderBottom: '1px solid #000' }}
      >
        <img 
          src={logo} 
          alt="Logo" 
          style={{ width: '200px', paddingBottom: '10px' }} 
        />
      </header>
      
      <nav className="flex flex-column p-my-3 p-gap-3 w-11" style={{maxWidth: '700px'}}>
            <Password 
                id="passwordInput"
                placeholder="Contraseña"
                value={password}
                onChange={handlePasswordChange}
                toggleMask
                feedback={false}
                className="w-full mb-3 mt-3"
            />
            <Button
                type="submit"
                label="Validar contraseña"
                className="p-button-rounded p-button-outlined w-full text-white mt-3"
                style={{backgroundColor: '#4545ff'}}
                onClick={handleValidatePassword}
            />
      </nav>
    </div>
  );
}